import store from '../store';

export default {
  userCanUse(resourcePermissions = []) {
    if (!resourcePermissions.length) return true;
    return !!resourcePermissions.filter((value) =>
      (store.getters.userPermissions || []).includes(value)
    ).length;
  },
};
